import { Box, Stack } from '@mui/material';
import React from 'react';

import { DropdownItem, SelectMenu } from '../../../../../components/atoms/SelectMenu';
import { AddressDataType } from '../../../../../components/organisms/StructureAddress';
import { StructureAddressContactLayout } from '../../../../../components/templates/StructureAddressContactLayout';
import { contactType } from '../../../../ClientStructure/AddEditClient/AddClientData.data';

export interface FreightDestinationAddressSectionProps {
  isCustomAddress: boolean;
  destinationAddressOptions: DropdownItem[];
  selectedOption?: string;
  onSelectOption: (value: string) => void;
  addressData: AddressDataType[];
  editAddressData?: AddressDataType;
  structureAddressDataset: AddressDataType[];
  setStructureAddressDataset: (dataset: AddressDataType[]) => void;
  setEditAddressData: (value: AddressDataType | undefined) => void;
  setAddressData: (data: AddressDataType[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing; addressForm shape untyped at source.
  addressForm: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing; addressForm shape untyped at source.
  setAddressForm: (form: any[]) => void;
}

export const FreightDestinationAddressSection: React.FC<FreightDestinationAddressSectionProps> = ({
  isCustomAddress,
  destinationAddressOptions,
  selectedOption,
  onSelectOption,
  addressData,
  editAddressData,
  structureAddressDataset,
  setStructureAddressDataset,
  setEditAddressData,
  setAddressData,
  addressForm,
  setAddressForm,
}) => {
  if (!isCustomAddress) {
    return (
      // A Box, not a TableRow: the panel around this section is a flex column
      // now, and a stray <tr> in it is markup no browser lays out reliably.
      <Box>
        <Stack alignItems="center" justifyItems="center" direction="row" spacing={1}>
          {destinationAddressOptions.length > 0 && (
            <SelectMenu
              label="Destination Address"
              id="destination-address"
              items={destinationAddressOptions}
              disabled={false}
              selectedValue={selectedOption}
              onChange={onSelectOption}
            />
          )}
        </Stack>
      </Box>
    );
  }

  return (
    <Box>
      <StructureAddressContactLayout
        heading="Address"
        isAddress={true}
        isOneAddress={true}
        renderNotes={false}
        contactType={contactType}
        addressDataset={structureAddressDataset || []}
        contactDataset={[]}
        contactFormData={[]}
        addressFormData={addressData}
        editAddressFormData={editAddressData}
        enableContactNumber
        onClickAddressEdit={(_event, index) => {
          if (index < 0 || index >= structureAddressDataset.length) return;
          const updated = [...structureAddressDataset];
          const [selected] = updated.splice(index, 1);
          setStructureAddressDataset(updated);
          setEditAddressData(selected);
        }}
        onClickAddressDelete={(_event, index) => {
          if (index < 0 || index >= structureAddressDataset.length) return;
          const updated = structureAddressDataset.map((item, i) =>
            i === index ? { ...item, isActive: false } : item
          );
          setStructureAddressDataset(updated);
        }}
        onStructureAddressChange={(value) => setAddressData(value)}
        handleAddressCreate={(index) => {
          if (index < 0 || index >= addressData.length) return;
          const target = addressData[index];
          const newEntry: AddressDataType = {
            ...target,
            isActive: true,
            ...(target.isManual ? { googleAddress: '' } : {}),
          };
          setStructureAddressDataset([...structureAddressDataset, newEntry]);
          setAddressData(addressData.filter((_, i) => i !== index));
        }}
        addressForm={addressForm}
        setAddressForm={setAddressForm}
        addFormEnabledByDefault
        enableAddressContactFields
        hideAddressType
      />
    </Box>
  );
};
